import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  HostListener,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-multi-select',
  templateUrl: './multi-select.component.html',
  styleUrls: ['./multi-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MultiSelectComponent),
      multi: true
    }
  ]
})
export class MultiSelectComponent implements OnInit, ControlValueAccessor {
  @Input() list: any[] = [];
  @Input() listDisplay: string = 'name';
  @Input() placeholder = 'Seleccionar...';
  @Output() selectedItems: EventEmitter<any[]> = new EventEmitter();

  isOpen = false;
  _value: any[] = [];

  constructor(private eRef: ElementRef) {}

  ngOnInit() {}

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  isSelected(item: any): boolean {
    return this._value.some(v => v.id === item.id);
  }

  selectItem(item: any) {
    if (this.isSelected(item)) {
      this._value = this._value.filter(v => v.id !== item.id);
    } else {
      this._value = [...this._value, item];
    }
    this.onChange(this._value);
    this.onTouch();
    this.selectedItems.emit(this._value);
  }
  get displayValue(): string {
    if (!this._value || this._value.length === 0) return '';
    return this._value.map(v => v[this.listDisplay] || v).join(', ');
  }
  onChange: any = () => {};
  onTouch: any = () => {};

  writeValue(obj: any): void {
    this._value = obj || [];
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }
  @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {
    if (this.isOpen && !this.eRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  }
}
